import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminBackgroundTaskStatus } from '../enums/admin-background-task-status';
import { BackgroundTaskStatusProviderService } from '../providers';

@Pipe({
  name: 'adminBackgroundTaskStatus',
})
export class BackgroundTaskStatusPipe implements PipeTransform {
  private readonly provider = inject(BackgroundTaskStatusProviderService);

  public transform(status: AdminBackgroundTaskStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
